import React from "react";

type PropTypes = {
    children: any;
}

/**
 * Wrap the main headline with last change of the document
 */
function HeadlineOne({ children }: PropTypes) {
    if (undefined === children) {
        return <div />;
    }
    return (
        <>
            <h1>{children}</h1>
        </>
    );
}

export default HeadlineOne;

